import { Component, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';

@Component({
  selector: 'app-select-period',
  templateUrl: './select-period.component.html',
  styleUrls: ['./select-period.component.scss']
})
export class SelectPeriodComponent implements  OnDestroy {

  public items: any[] = [
    { name: 'Día', value: 'day' },
    { name: 'Semana', value: 'week' },
    { name: 'Mes', value: 'month' },
  ];

  public period: any = [];
  public ngxDisabled = false;
  period$: Subscription;

  constructor(
    public sanitizer: DomSanitizer,
    private sharedService: SharedService
  ) {
    this.period$ = this.sharedService.sharedPeriod.subscribe(period => {
      this.period = period;
    });
  }

  public style(data: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(data);
  }

  ngOnDestroy() {
    this.period$.unsubscribe();
  }

  changePeriod(event: any) {
    this.period = event;
    this.sharedService.nextPeriod = this.period;
  }
}
